import LocalDateTime from '@/types/localdatetime';

export default class LocalDateTimeUtils {
  static computeRawOffsetDays(offsetDay: Date) {
    // @ts-ignore
    return new Intl.DateTimeFormat('en-US', { dateStyle: 'short' }).format(offsetDay);
  }

  static computeOffsetDaysString(offset: number) {
    // Extra work here is to acquire the date in the browser's local time instead of UTC
    const offsetDay = new Date();
    offsetDay.setDate(new Date().getDate() + offset);
    const rawDate = LocalDateTimeUtils.computeRawOffsetDays(offsetDay);
    const mmddyyyparts = rawDate.split('/');
    const paddedMonth = mmddyyyparts[0].length === 1 ? `0${mmddyyyparts[0]}` : mmddyyyparts[0];
    const paddedDay = mmddyyyparts[1].length === 1 ? `0${mmddyyyparts[1]}` : mmddyyyparts[1];
    const paddedYear = mmddyyyparts[2].length === 2 ? `20${mmddyyyparts[2]}` : mmddyyyparts[2];
    const formatted = `${paddedYear}-${paddedMonth}-${paddedDay}`;
    return formatted;
  }

  static toDateArray(date:string) {
    if (!date) {
      return null;
    }
	  const localDate: LocalDateTime = new LocalDateTime(date);
    return localDate.toDateArray();
  }

  static toDateString(date:number[]|null) {
    if (!date) {
      return null;
    }
	  const localDate: LocalDateTime = new LocalDateTime(date);
    return localDate.toISODateString();
  }
}
